import { Box, Icon, Image, Theme, Typography } from "@outschool/backpack";
import { faSearch } from "@outschool/icons";
import { TrackedButton } from "@outschool/ui-components-shared";
import { useLinkComponent } from "@outschool/ui-utils";
import React from "react";

export function EmptyProfileCard({
  imageUrl,
  topText,
  bottomText,
  buttonText,
  buttonTo,
}: {
  imageUrl: string;
  topText: string;
  bottomText: string;
  buttonText: string;
  buttonTo: string;
}) {
  const Link = useLinkComponent();

  return (
    <Box
      flex
      sx={(theme: Theme) => ({
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        borderRadius: 10,
        height: 220,
        border: `1px solid ${theme.palette.neutral[100]}`,
        backgroundColor: theme.palette.neutral[50],
        mx: "1rem",
        mt: "1rem",
      })}
    >
      <Image
        src={imageUrl}
        sx={{
          width: 80,
          height: "auto",
        }}
      />
      <Typography
        variant="body2"
        emphasized
        sx={(theme: Theme) => ({
          fontSize: "1.6rem",
          color: theme.palette.neutral[500],
        })}
      >
        {topText}
      </Typography>
      <Typography
        variant="body2"
        sx={(theme: Theme) => ({
          fontSize: "1.4rem",
          color: theme.palette.neutral[500],
          marginBottom: 10,
        })}
      >
        {bottomText}
      </Typography>

      <Link to={buttonTo}>
        <TrackedButton
          trackingLabel="parent_profile_find_next_teacher"
          variant="outlined"
          sx={{ display: "flex", gap: "1rem" }}
        >
          <Icon icon={faSearch} /> {buttonText}
        </TrackedButton>
      </Link>
    </Box>
  );
}
